import firebase from 'firebase'
import { firestore, query, collection, where, getAll } from 'firebase/firestore';
import {db, auth} from '../db';
import Events from './Events';

// helper Function
function err(e) {
  return {success: false, error: e};
}

//GameDetail-Testers.vue
async function assignTimeSlot(gameId, testerId, timeSlot) {

    function err(e) {
        return {success: false, error: e};
    }

    return new Promise(async (resolve, reject) => {

        // check if this gameid exist in db (not sure if this is necessary)
        db.collection("Game").doc(gameId).get()
        .then(doc => {
            console.log(doc.exists);
            if (!doc.exists) {
                console.log("game does not exist");
                reject({success: false, error: "game does not exist"});  
            }
        }).catch(e => reject(err(e)));

        // check if this user exist in db (not sure if this is necessary)
        db.collection("User").doc(testerId).get()
        .then(doc => {
            console.log(doc.exists);
            if (!doc.exists) {
                console.log("user does not exist");
                reject({success: false, error: "user does not exist"});  
            }
        }).catch(e => reject(err(e)));

        // adding new timeslot to db
        db.collection("Timeslot").doc().set({
            gameId,
            testerId,
            timeSlot
        })
        .then(() => {
            Events.logEvent("playtester.assigned", { gameId, testerId });
            resolve({success: true});
        })
        .catch(e => reject(err(e)));
    })
}

async function getTimeSlot(gameId, testerId) {
    return new Promise((resolve, reject) => {
        if (gameId === "" || testerId === "") {
            reject(() => {
                return {success: false, error: "'gameId' or 'testerId' were invalid"}
            })
        }
        db.collection("Timeslot")
        .where("gameId", "==", gameId)
        .where("testerId", "==", testerId)
        .limit(1)
        .get()
        .then(querySnap => {
            let res = []
            // not an error if no timeslots
            // if so, then we return empty array
            querySnap.forEach(doc => {
                doc.data().timeSlot.forEach(element => {
                    res.push([element[0], element[1]])
                })
            })
            resolve(() => {return {success: true, data: res}})
        }).catch(e => {reject (() => {return {success: false, error: e}})})
    })
}

//GameDetail-Testers.vue
async function deleteTester(gameId, testerId) {
    function err(e) {
        return {sucess: false, error: e};
    }

    return new Promise(async (resolve, reject) => {
        // check if this gameid exist in db (not sure if this is necessary)
        db.collection("Game").doc(gameId).get()
        .then(doc => {
            console.log(doc.exists);
            if (!doc.exists) {
                console.log("game does not exist");
                reject({success: false, error: "game does not exist"});  
            }
        }).catch(e => reject(err(e)));

        // check if this user exist in testerIDs (not sure if this is necessary)
        db.collection("Game").doc(gameId).get()
        .then(doc => {
            // check if game tester array is empty
            if (!doc.data().testerIDs) {
                console.log("this game document does not have any game testers");
                reject({success: false, error: "this game document does not have any game testers"});  
            }
            // check if this testerId exist inside of game tester array
            if (!doc.data().testerIDs.includes(testerId)) {
                console.log("this game tester does not exisit inside of game testers")
                reject({success: false, error: "this game tester does not exisit inside of game testers"});  
            }

            // delete this testerId from game testerIDs
            db.collection("Game").doc(gameId).update({
                    
                testerIDs: doc.data().testerIDs.filter(tID => tID !== testerId)
            })
            .then(res => {
                // return {success: true};
                Events.logEvent("playtester.removed", { gameId, testerId });
                resolve({success: true})
            }).catch(e => reject(err(e)));

        }).catch(e => reject(err(e)));
    })
}

// create test session - initiated by tester testerID for project projectID
async function createTestSession(projectID, testerID, playPeriodID) {
    function err(e) {
      return { success: false, error: e };
    }
    return new Promise(async (resolve, reject) => {
        // adding new test session to db
        db.collection("Test").add({
            testerID: testerID,
            gameID: projectID,
            playPeriodID: playPeriodID,
            developerID: null,
            streamToken: null,
            status: 'Created',
            startDateTime: null,
            endDateTime: null,
            playtesterInfo: null,
            audioTranscript: [],
            videoRecording: null,
            webcamRecording: null,
            instructions: [],
            bugs: [],
            testFocus: '',
            notes: []
        })
        .then((docRef) => {
            Events.logEvent("session.created", { sessionID: docRef.id, gameId: projectID, testerId: testerID });
            resolve({success: true, data: docRef.id});
        })
        .catch(e => reject(err(e)));
        });
  }

// If the user already started a playtest for the specified game, return the data for it
async function loadTestSession(projectID, testerID, playPeriodID) {
  return new Promise(async (resolve, reject) => {
    if (projectID === null || testerID === null) {
        reject(err({ success: false, error: "invalid project/tester" }));
      }
  
    // fetching test session from db
    let q = await db.collection("Test")
      .where("gameID", "==", projectID)
      .where("testerID", "==", testerID)
      .where("playPeriodID", "==", playPeriodID)
      .where("status", "==", 'Created')
      .get();
    if (q.empty) {
      q = await db.collection("Test")
        .where("gameID", "==", projectID)
        .where("testerID", "==", testerID)
        .where("playPeriodID", "==", playPeriodID)
        .where("status", "==", 'Active')
        .get();
    }
      
    if (q.empty) {
      reject({ 
        success: false, 
        exists: false
      });
    } else {
      // collect all available test sessions in array `data`, the task did not specify 
      // how to handle multiple test sessions being available, so just return all of
      // them in an array and let the caller decide. 
      let data = [];
      q.forEach((session) => {
        let new_data = {
          sessionID: session.id,
          gameID: session.data().gameID,
          testerID: session.data().testerID,
          playPeriodID: session.data().playPeriodID,
          playtesterInfo: session.data().playtesterInfo,
          audioTranscript: session.data().audioTranscript,
          videoRecording: session.data().videoRecording,
          webcamRecording: session.data().webcamRecording,
          instructions: session.data().instructions,
          bugs: session.data().bugs,
          status: session.data().status
        };
        data.push(new_data);
      });
      resolve({ success: true, data: data });
    }
  }).catch((e) => reject({ success: false, exists: false }));
}

// If the user already started a playtest for the specified game, return the data for it
async function loadCompletedTestSession(projectID, testerID, playPeriodID) {
  return new Promise(async (resolve, reject) => {
    if (projectID === null || testerID === null) {
      reject(err({ success: false, error: "invalid project/tester" }));
    }

    // fetching test session from db
    let q = await db.collection("Test")
      .where("gameID", "==", projectID)
      .where("testerID", "==", testerID)
      .where("playPeriodID", "==", playPeriodID)
      .where("status", "==", 'Done')
      .get();

    if (q.empty) {
      reject({
        success: false,
        exists: false
      });
    } else {
      // collect all available test sessions in array `data`, the task did not specify 
      // how to handle multiple test sessions being available, so just return all of
      // them in an array and let the caller decide. 
      let data = [];
      q.forEach((session) => {
        let new_data = {
          sessionID: session.id,
          gameID: session.data().gameID,
          testerID: session.data().testerID,
          playPeriodID: session.data().playPeriodID,
          playtesterInfo: session.data().playtesterInfo,
          audioTranscript: session.data().audioTranscript,
          videoRecording: session.data().videoRecording,
          webcamRecording: session.data().webcamRecording,
          instructions: session.data().instructions,
          bugs: session.data().bugs,
          status: session.data().status
        };
        data.push(new_data);
      });
      resolve({ success: true, data: data });
    }
  }).catch((e) => reject({ success: false, exists: false }));
}
  
// developer(ID) joining an active test session(ID)
async function joinTestSession(sessionID, developerID) {
  return new Promise(async (resolve, reject) => {
    db.collection("Test").doc(sessionID).get()
    .then((doc) => {
        console.log(doc.data());
      if (!doc.exists) {
        reject({ 
          success: false, 
          error: "test session with given sessionID does not exist" 
        });
  
      } else {
        db.collection("Test").doc(doc.id)
        .update({
            developerID
        })
        .then(res => {
            resolve({ success: true });
        })
        .catch((e) => reject({ success: false, error: e }));
      }
    }).catch((e) => reject({ success: false, error: e }));
  });
}
  
// get all test sessions for a given game - used in gamedetails - analysis page
async function getGameTestSessions(gameID) {
    return new Promise((resolve, reject) => {
        db.collection('Test')
        .where('gameID', '==', gameID)
        .where('status', '==', 'Done')
        .get()
        .then(q => {
            if (q.empty) { // no sessions - return empty array
                resolve({success: true, data: []});
            } else  {
                let sessions = [];
                q.forEach(doc => {
                    let newDoc = {
                        id: doc.id,
                        focus: doc.data().testFocus,
                        startDateTime: doc.data().startDateTime.toDate(),
                        endDateTime: doc.data().endDateTime.toDate(),
                        notes: doc.data().notes
                    }
                    sessions.push(newDoc);
                });
                // sort sessions by startDateTime in descending order (most recent at the top) so they're displayed that way
                sessions = sessions.sort((a,b) => {
                    if (a.startDateTime > b.startDateTime) {
                        return -1;
                    } else if (b.startDateTime > a.startDateTime) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
                resolve({success: true, data: sessions});
            }
        })
        .catch(e => reject({success: false, error: e}));
    });
}
  
// add new session note with given note text
async function addSessionNote(sessionID, note) {
    return new Promise((resolve, reject) => {
        db.collection('Test').doc(sessionID)
        .update({
            // get current timestamp from system and use that as the note timestamp
            notes: firebase.firestore.FieldValue.arrayUnion({timestamp: firebase.firestore.Timestamp.now(), text: note})
        })
        .then(ref => {
            console.log({timestamp: firebase.firestore.Timestamp.now(), text: note});
            resolve({success: true});
        })
        .catch(e => reject({success: false, error: e}));
    });
}
  
// update session(ID) test (new)focus
async function updateTestSessionFocus(sessionID, newFocus) {
    return new Promise((resolve, reject) => {
        if (!newFocus || !newFocus.length) reject({success: false, error: "newFocus not defined or is blank"});
        else {
            db.collection('Test').doc(sessionID)
            .update({
                testFocus: newFocus
            })
            .then(ref => {
                resolve({success: true});
            })
            .catch(e => reject({success: false, error: e}));
        }
    });
}
  
// get all test sessions for a given playtester for a given game
async function getPlaytesterSessions(gameID, testerID) {
  return new Promise((resolve, reject) => {
    db.collection('playPeriod')
      .where('gameID', '==', gameID)
      .where('testerIDs', 'array-contains', testerID)
      .get()
      .then(q => {
        if (q.empty) {
          // no sessions - return empty array
          resolve({ success: true, data: [] });
        } else {
          let sessions = [];

          q.forEach(doc => {
            let newDoc = {
              id: doc.id,
              name: doc.data().name,
              playtestInstructions: doc.data().instructions,
              questions: doc.data().questions,
              startTime: doc.data().startTime,
              endTime: doc.data().endTime,
              link: doc.data().link || ""
            };

            sessions.push(newDoc);
          });

          // sort sessions by startDateTime in descending order
          // (most recent at the top)
          sessions = sessions.sort((a, b) => {
            if (a.startTime > b.startTime) {
              return -1;
            } else if (b.startTime > a.startTime) {
              return 1;
            } else {
              return 0;
            }
          });

          resolve({
            success: true,
            data: sessions
          });
        }
      })
      .catch(e => reject({
        success: false,
        error: e
      }));
  });
}
// Get incomplete playtester sessions for a given game
async function getIncompletePlaytesterSessions(gameID, testerID) {
  return new Promise((resolve, reject) => {
    db.collection('Test')
      .where('gameID', '==', gameID)
      .where('testerID', '==', testerID)
      .where('status', "==", "Done")
      .get()
      .then(q => {
        let completedPlaytests = [];
        q.forEach((session) => {
          if (!completedPlaytests.includes(session.data().playPeriodID)) {
            completedPlaytests.push(session.data().playPeriodID);
          }
        });
        db.collection('playPeriod')
          .where('gameID', '==', gameID)
          .where('testerIDs', 'array-contains', testerID)
          .get()
          .then(q2 => {
            if (q2.empty) { // Game contains no playtest periods
              resolve({ success: true, count: 0 });
            } else {
              let existingPlaytestPeriods = [];
              q2.forEach(doc => {
                if (!existingPlaytestPeriods.includes(doc.id)) {
                  existingPlaytestPeriods.push(doc.id);
                }
              });
              let total = 0;
              existingPlaytestPeriods.forEach(playtestPeriod => {
                if (!completedPlaytests.includes(playtestPeriod)) {
                  total += 1;
                }
              })
              resolve({ success: true, count: total });
            }
          })
          .catch(e => reject({ success: false, error: e }));
      })
      .catch(e => reject({ success: false, error: e }));
  });
}
// Get completed playtester sessions for a given game
async function getCompletedPlaytesterSessions(gameID, testerID) {
  return new Promise((resolve, reject) => {
    db.collection('Test')
      .where('gameID', '==', gameID)
      .where('testerID', '==', testerID)
      .where('status', "==", "Done")
      .get()
      .then(q => {
        if (q.empty) { // no sessions - return empty array
          resolve({ success: true, data: [] });
        } else {
          let data = [];
          q.forEach((session) => {
            let new_data = {
              sessionID: session.id,
              gameID: session.data().gameID,
              testerID: session.data().testerID,
              playPeriodID: session.data().playPeriodID,
              playtesterInfo: session.data().playtesterInfo,
              audioTranscript: session.data().audioTranscript,
              videoRecording: session.data().videoRecording,
              webcamRecording: session.data().webcamRecording,
              instructions: session.data().instructions,
              bugs: session.data().bugs,
              status: session.data().status
            };
            data.push(new_data);
          });
          resolve({ success: true, data: data });
        }
      })
      .catch(e => reject({ success: false, error: e }));
  });
}
// Check if every playtest period has been completed by the user
async function allPlaytesterSessionsCompleted(gameID, testerID) {
  return new Promise((resolve, reject) => {
    db.collection('Test')
      .where('gameID', '==', gameID)
      .where('testerID', '==', testerID)
      .where('status', "==", "Done")
      .get()
      .then(q => {
          let completedPlaytests = [];
          q.forEach((session) => {
            if (!completedPlaytests.includes(session.data().playPeriodID)) {
              completedPlaytests.push(session.data().playPeriodID);
            }
          });
          db.collection('playPeriod')
            .where('gameID', '==', gameID)
            .where('testerIDs', 'array-contains', testerID)
            .get()
            .then(q2 => {
              if (q2.empty) { // Game contains no playtest periods
                resolve({ success: true, data: true });
              } else {
                let existingPlaytestPeriods = [];
                q2.forEach(doc => {
                  if (!existingPlaytestPeriods.includes(doc.id)) {
                    existingPlaytestPeriods.push(doc.id);
                  }
                });

                existingPlaytestPeriods.forEach(playtestPeriod => {
                  if (!completedPlaytests.includes(playtestPeriod)) {
                    resolve({ success: true, data: false });
                  }
                })
                resolve({ success: true, data: true });
              }
            })
            .catch(e => reject({ success: false, error: e }));
      })
      .catch(e => reject({ success: false, error: e }));
  });
}
// check if game(ID) has an active test session for tester(ID)
async function checkGameHasActiveTestSession(gameID, testerID) {
    return new Promise((resolve, reject) => {
        if (gameID===null || gameID==='') reject({success: false, error: "gameID is invalid"});
        else {
            db.collection("Game").doc(gameID).get()
            .then(doc => {
                if (!doc.exists) reject({success: false, error: "game doesn't exist"});
                else { // project exists
                    // check if testerID is associated with this game
                    if (testerID && !doc.data().testerIDs.includes(testerID)) reject({success: false, error: "tester is not associated with this game"});
                    else {
                        // check if any test sessions for this project exist and are active
                        db.collection("Test")
                        .where("gameID", "==", doc.id)
                        .where("status", "==", "Active")
                        .get()
                        .then(q => {
                            // no sessions => return
                            if (q.empty) resolve({success: true, data: {activeSessions: false}})
                            else {
                                // populate test session list and return
                                let sessions = [];
                                q.forEach(session => {
                                    let newSession = {
                                        ...session.data(),
                                        sessionID: session.id
                                    }
                                    resolve({success: true, data: {activeSession: true, session: newSession}});
                                });
                            }
                        })
                        .catch(e => reject({success: false, error: e}));
                    }
                }
            })
            .catch(e => reject({success: false, error: e}));
        }
    });
}
  
// update test session(ID) with current datetime as start date and active status
async function testerStartTestSession(sessionID) {
    return new Promise((resolve, reject) => {
        db.collection("Test").doc(sessionID).update({
            startDateTime: firebase.firestore.Timestamp.now(),
            status: "Active"
        })
        .then(ref => {
            Events.logEvent("session.started", { sessionID });
            resolve({success: true});
        })
        .catch(e => reject({success: false, error: e}));
    });
}
  
// update test session(ID) with current datetime as end date and done status
async function testerEndTestSession(sessionID) {
    return new Promise((resolve, reject) => {
        db.collection("Test").doc(sessionID).update({
            endDateTime: firebase.firestore.Timestamp.now(),
            status: "Done"
        })
        .then(ref => {
            Events.logEvent("session.completed", { sessionID });
            resolve({success: true});
        })
        .catch(e => reject({success: false, error: e}));
    });
}
  
// get list of developer notes for a test session(ID)
async function getTestSessionNotes(sessionID) {
    return new Promise((resolve, reject) => {
        db.collection('Test').doc(sessionID)
        .get()
        .then(doc => {
            resolve({success: true, data: doc.data().notes});
        })
        .catch(e => reject({success: false, error: e}));
    });
}
  
// get test session(ID) test focus
async function getTestSessionFocus(sessionID) {
    return new Promise((resolve, reject) => {
        db.collection('Test').doc(sessionID)
        .get()
        .then(doc => {
            resolve({success: true, data: doc.data().testFocus});
        })
        .catch(e => reject({success: false, error: e}));
    });
}
// Save recordings for a playtest session
async function savePlaytest(newData) {
  return new Promise((resolve, reject) => {
    db.collection("Test").doc(newData.sessionID).update({
      status: newData.status,
      audioTranscript: newData.audioTranscript,
      bugs: newData.bugs,
      videoRecording: newData.videoRecording,
      webcamRecording: newData.webcamRecording,
      instructions: newData.instructions,
      playtesterInfo: newData.playtesterInfo,
    })
    .then(ref => {
      resolve({ success: true });
    })
    .catch(e => reject({ success: false, error: e }));
  })
}
// Save Audio transcript
async function saveAudioTranscript(audioTranscript, sessionID) {
  db.collection("Test").doc(sessionID).update({
    audioTranscript: audioTranscript,
  })
}

// Save Video Recording to firestore
//idk what sessionId is supposed to be so I just changed it to playPeriodId
//I say this because it tries getting sessionId from local storage but it does not exist there
async function saveVideoRecordingUrl(videoFile, gameID, periodID, testerID) {
  return new Promise((resolve, reject) => {
    const videoStorage = firebase.storage().ref();
    let videoName = `${gameID}/${periodID}/${testerID}/${videoFile.name}`;
    let videoRef = videoStorage.child(`videos/${videoName}`);
    
    videoRef.put(videoFile)
      .then(() => {
        Events.logEvent("video.uploaded", { gameID, periodID, testerID, bytes: videoFile.size });
        resolve({ success: true });
      })
      .catch(error => {
        console.error('Error uploading video:', error);
        reject({ success: false, error: error });
      });
  });
}

// Get Video Recording Url
async function getVideoRecordingUrl(videoFile, gameID, periodID, testerID) {
  return new Promise((resolve, reject) => {
    const videoStorage = firebase.storage().ref();
    let videoName = `${gameID}/${periodID}/${testerID}/${videoFile.name}`;
    let videoRef = videoStorage.child(`videos/${videoName}`);

    videoRef.getDownloadURL()
      .then(url => {
        resolve(url);
      })
      .catch(error => {
        console.error('Failed to fetch video URL:', error);
        reject(error);
      });
  });
}

// Save Webcam Recording to firestore
async function saveWebcamRecordingUrl(webcamFile, gameID, periodID, testerID) {
  return new Promise((resolve, reject) => {
    const webcamStorage = firebase.storage().ref();
    let webcamName = `${gameID}/${periodID}/${testerID}/${webcamFile.name}`;
    let webcamRef = webcamStorage.child('webcam/' + webcamName);
    
    webcamRef.put(webcamFile)
      .then(() => {
        resolve({ success: true });
      })
      .catch(error => {
        console.error('Error uploading webcam:', error);
        reject({ success: false, error: error });
      });
  });
}

// Get Webcam Recording Url
async function getWebcamRecordingUrl(webcamFile, gameID, periodID, testerID) {
  return new Promise((resolve, reject) => {
    const webcamStorage = firebase.storage().ref();
    let webcamName = `${gameID}/${periodID}/${testerID}/${webcamFile.name}`;
    let webcamRef = webcamStorage.child('webcam/' + webcamName);

    webcamRef.getDownloadURL()
      .then(url => {
        resolve(url);
      })
      .catch(error => {
        console.error('Failed to fetch webcam URL:', error);
        reject(error);
      });
  });
}

async function deleteFile() {

}

export default {
  assignTimeSlot,
  getTimeSlot,
  deleteTester,
  createTestSession,
  loadTestSession,
  loadCompletedTestSession,
  joinTestSession,
  getGameTestSessions,
  addSessionNote,
  getTestSessionNotes,
  updateTestSessionFocus,
  getPlaytesterSessions,
  getIncompletePlaytesterSessions,
  getCompletedPlaytesterSessions,
  allPlaytesterSessionsCompleted,
  getTestSessionFocus,
  checkGameHasActiveTestSession,
  testerStartTestSession,
  testerEndTestSession,
  savePlaytest,
  saveVideoRecordingUrl,
  getVideoRecordingUrl,
  saveWebcamRecordingUrl,
  getWebcamRecordingUrl,

}



// WEBPACK FOOTER //
// ./src/Firestore/GameTesting.js